import type { TAppThunk, TAppDispatch, TGetState } from 'store/types'
import { appThunksRegistry } from './holder'

const createWrapper = <TDependency, TReturn>(
  getDependency: () => TAppThunk<TDependency>
) => {
  return (thunk: (dep: TDependency) => TAppThunk<TReturn>) => {
    return async (
      dispatch: TAppDispatch,
      getState: TGetState
    ): Promise<TReturn> => {
      const dep: TDependency = getDependency()(dispatch, getState)
      return thunk(dep)(dispatch, getState)
    }
  }
}

const getter = () => {
  return appThunksRegistry
}

export const withAppThunks = createWrapper(() => getter)
